// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".minHeight[data-v-41d4bca6] {\n  min-height: 36px;\n}\n", ""]);
// Exports
module.exports = exports;
